import { Scene, StandardMaterial, SubMesh, Texture } from '@babylonjs/core';

export class LazyTextureMaterial extends StandardMaterial {
    public constructor(name: string, scene: Scene, textureUrl: string, subMesh: SubMesh) {
        super(name, scene);

        this.disableDepthWrite = true;
        this.fogEnabled = false;

        this._subMesh = subMesh;
        this._textureUrl = textureUrl;
        this._loaded = false;

        scene.registerBeforeRender(this._checkVisibility);
    }

    private readonly _checkVisibility = () => {
        const scene = this.getScene();
        const mesh = this._subMesh.getMesh();

        if (!this._loaded && mesh?.isVisible && scene.activeCamera.isInFrustum(this._subMesh)) {
            this.emissiveTexture = new Texture(this._textureUrl, scene);

            this.emissiveTexture.wrapU = Texture.CLAMP_ADDRESSMODE;
            this.emissiveTexture.wrapV = Texture.CLAMP_ADDRESSMODE;

            this._loaded = true;
            scene.unregisterBeforeRender(this._checkVisibility);
        }
    }

    private _loaded: boolean;
    private readonly _textureUrl: string;
    private readonly _subMesh: SubMesh;
}
